import React from 'react';
import { motion } from 'framer-motion';
import { HERO_CONTENT } from '../lib/about-data';
import { cn } from '../../../shared/ui/kit/utils';

interface AboutHeroProps {
    className?: string;
}

export const AboutHero: React.FC<AboutHeroProps> = ({ className }) => {
    return (
        <div className={cn('text-center py-12 px-6', className)}>
            <motion.div
                initial={{ scale: 0, rotate: -180 }}
                animate={{ scale: 1, rotate: 0 }}
                transition={{ 
                    type: 'spring',
                    stiffness: 200,
                    damping: 20,
                    duration: 0.8 
                }}
                className="relative w-20 h-20 mx-auto mb-6"
            >
                <div className="about-logo absolute inset-0 rounded-2xl bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center text-white text-3xl font-bold shadow-lg overflow-hidden">
                <span className="relative z-10">{HERO_CONTENT.logo}</span>
                
                <div className="logo-shimmer absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full" />
                
                <div className="absolute inset-0 bg-gradient-to-br from-blue-400/20 to-purple-400/20 blur-xl" />
                </div>
                
                <motion.div
                    animate={{ 
                        y: [0, -10, 0],
                        opacity: [0.5, 1, 0.5],
                    }}
                    transition={{ duration: 3, repeat: Infinity }}
                    className="absolute -top-2 -right-2 w-3 h-3 rounded-full bg-emerald-400"
                />
                <motion.div
                    animate={{ 
                        y: [0, 8, 0],
                        opacity: [0.3, 0.8, 0.3],
                    }}
                    transition={{ duration: 2.5, repeat: Infinity, delay: 0.5 }}
                    className="absolute -bottom-1 -left-1 w-2 h-2 rounded-full bg-amber-400"
                />
            </motion.div>

            <motion.h1
                initial={{ y: 30, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.3, duration: 0.6 }}
                className="about-title text-3xl sm:text-4xl font-bold tracking-tight text-gray-900 dark:text-gray-100 mb-3"
            >
                {HERO_CONTENT.title}
            </motion.h1>

            <motion.p
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.4, duration: 0.5 }}
                className="about-subtitle text-lg text-gray-600 dark:text-gray-400 mb-4 max-w-md mx-auto"
            >
                {HERO_CONTENT.subtitle}
            </motion.p>

            <motion.p
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.5, duration: 0.5 }}
                className="about-description text-sm text-gray-500 dark:text-gray-500 max-w-lg mx-auto leading-relaxed"
            >
                {HERO_CONTENT.description}
            </motion.p>

            <div className="absolute top-20 left-10 w-32 h-32 bg-blue-500/5 rounded-full blur-3xl pointer-events-none" />
            <div className="absolute top-32 right-10 w-40 h-40 bg-purple-500/5 rounded-full blur-3xl pointer-events-none" />
        </div>
    );
};